<template>
  <v-card>
    <v-toolbar color="primary" density="comfortable">
      <v-toolbar-title class="text-white">
        {{ title }}
      </v-toolbar-title>
      <v-spacer />
      <div class="d-flex ga-2">
        <v-tooltip location="left">
          <template #activator="{ props }">
            <v-btn icon variant="text" v-bind="props" @click="cancel">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
          Fermer
        </v-tooltip>
        <v-tooltip location="left">
          <template #activator="{ props }">
            <v-btn icon variant="text" v-bind="props" @click="save">
              <v-icon>mdi-content-save-all</v-icon>
            </v-btn>
          </template>
          Sauvegarder
        </v-tooltip>
      </div>
    </v-toolbar>

    <v-card-text>
      <v-text-field
        label="Plaque d'immatriculation"
        v-model="vehicle.plateNumber"
        required
      />

      <v-text-field label="Label" v-model="vehicle.label" />

      <VehicleInventoryEditor
        v-if="vehicle.id"
        :vehicle-id="vehicle.id"
        v-model="inventory"
      />
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import VehicleInventoryEditor from "./VehicleInventoryEditor.vue";
import {
  getVehicleById,
  getVehicleInventoryItems,
  postVehicle,
  putVehicle,
} from "@/utils/vehicle-api";
import { useRoute, useRouter } from "vue-router";
import { useAppStore } from "@/store";
import { Vehicle, VehicleInventoryItem } from "@/types";

const vehicle = ref<Vehicle>({
  plateNumber: "",
  label: "",
});

const route = useRoute();
const router = useRouter();
const appStore = useAppStore();
const inventory = ref<VehicleInventoryItem[]>([]);

const loading = ref(false);
const title = ref("");

const cancel = () => {
  router.push({ name: "vehicles" });
};

onMounted(async () => {
  try {
    loading.value = true;

    if (route.name === "NewVehicle") {
      title.value = "Créer un véhicule";
      return;
    }

    title.value = "Editer le véhicule";
    const v = await getVehicleById(route.params.id as string);
    vehicle.value = v;
    const inv = await getVehicleInventoryItems(route.params.id as string);
    inventory.value = inv;
  } catch (error) {
    // Ignore
  } finally {
    loading.value = false;
  }
});

const save = async () => {
  try {
    if (vehicle.value.id) {
      await putVehicle(vehicle.value);
      appStore.sendSuccessNotice("Vehicle has been updated.");
    } else {
      vehicle.value = await postVehicle(vehicle.value);
      appStore.sendSuccessNotice("New Vehicle has been added.");
      router.replace({
        name: "vehicle",
        params: { id: vehicle.value.id },
      });
    }
  } catch (error) {
    // Ignore, handled centraly in axios service
  }
};
</script>
